<!--<small class="debug">{{me}}</small>-->
<div style="width: 100%; height: 100%">
  @if (_ready) {
    <div class="chartContainer" style="width: 100%; height: 100%" >
      <!-- <div id="container1"> -->
      <highcharts-chart  style="display: flex;"  [callbackFunction]="chartCallback" [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="logChartInstance($event)"></highcharts-chart>
    <!-- </div> -->
  </div>
}
@if (!_ready) {
  <div>
    <app-loading [@fadeInOutAnimation] [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
  </div>
}
</div>
